/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Modification de l'ordre d'affichage d'un support autorisé.
 * @export
 * @interface UpdateSupportTunnelCommand
 */
export interface UpdateSupportTunnelCommand {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSupportTunnelCommand
     */
    isTunnelGLI?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupportTunnelCommand
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupportTunnelCommand
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSupportTunnelCommand
     */
    ordreAffichage?: number;
}

/**
 * Check if a given object implements the UpdateSupportTunnelCommand interface.
 */
export function instanceOfUpdateSupportTunnelCommand(value: object): value is UpdateSupportTunnelCommand {
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateSupportTunnelCommandFromJSON(json: any): UpdateSupportTunnelCommand {
    return UpdateSupportTunnelCommandFromJSONTyped(json, false);
}

export function UpdateSupportTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupportTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'isTunnelGLI': json['isTunnelGLI'] == null ? undefined : json['isTunnelGLI'],
        'tunnelId': json['tunnelId'],
        'id': json['id'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
    };
}

export function UpdateSupportTunnelCommandToJSON(json: any): UpdateSupportTunnelCommand {
    return UpdateSupportTunnelCommandToJSONTyped(json, false);
}

export function UpdateSupportTunnelCommandToJSONTyped(value?: UpdateSupportTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isTunnelGLI': value['isTunnelGLI'],
        'tunnelId': value['tunnelId'],
        'id': value['id'],
        'ordreAffichage': value['ordreAffichage'],
    };
}

